import { css } from '@emotion/css'
import { spacing, accessiblyHidden } from '@offerzen/pinata-shame'

const styles = {
  list: css({
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.default,
  }),

  accessiblyHidden: css(accessiblyHidden),
}

export default styles
